import { Injectable } from '@kaokei/use-vue-service';

@Injectable()
export class CountdownService {
  private unit = 60; // 倒计时的单元

  public current = 0;

  private timer = 0;

  private timeoutCallback: any;

  public setUnit(u: number) {
    this.unit = u;
  }

  public registerCallback(callback: any) {
    this.timeoutCallback = callback;
  }

  public unregisterCallback() {
    this.timeoutCallback = undefined;
  }

  public start() {
    this.current = this.unit;
    window.clearTimeout(this.timer);
    this.countdown();
  }

  public countdown() {
    if (this.current > 0) {
      this.current--;
      this.timer = window.setTimeout(() => this.countdown(), 1000);
    } else {
      if (this.timeoutCallback) {
        this.timeoutCallback();
      }
    }
  }
}
